import { useEffect, useState } from 'react';
import './AnimatedLogo.css';
import { BRAND } from '../../config/brand';

interface AnimatedLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  autoPlay?: boolean;
  className?: string;
  showText?: boolean;
}

const sizes = {
  sm: { width: 200, height: 120 },
  md: { width: 320, height: 180 },
  lg: { width: 450, height: 250 },
  xl: { width: 550, height: 300 },
};

export default function AnimatedLogo({
  size = 'md',
  autoPlay = true,
  className = '',
  showText = true,
}: AnimatedLogoProps) {
  const [isAnimating, setIsAnimating] = useState(false);
  const { width, height } = sizes[size];

  useEffect(() => {
    if (autoPlay) {
      const timer = setTimeout(() => setIsAnimating(true), 100);
      return () => clearTimeout(timer);
    }
  }, [autoPlay]);

  return (
    <div
      className={`animated-logo ${isAnimating ? 'animate' : ''} ${className}`}
      style={{ width, height, position: 'relative' }}
    >
      {/* Logo SVG */}
      <div className="logo-container">
        <img
          src="/logo.svg"
          alt={BRAND.displayDomain}
          className="logo-image"
          style={{
            width: '100%',
            height: showText ? '75%' : '100%',
            objectFit: 'contain',
          }}
        />
      </div>

      {/* Text below logo */}
      {showText && (
        <div className="logo-text-container">
          <span className="logo-text-main">{BRAND.storagePrefix}</span>
          <span className="logo-text-ai">.ai</span>
        </div>
      )}

      {/* Glow effect */}
      <div className="logo-glow" />
    </div>
  );
}
